<template>
  <div class="w-full">
    <div class="date-section">
      <p class="my-3">{{ $t("wizard.date") }}</p>
      <div class="date-section__container">
        <div
          v-ripple
          v-for="(day, index) in days"
          :key="index"
          class="day-of-week"
          :class="{
            selected: isDateSelected(day.date),
            disabled:
              isClosedDay(day.date) || !checkIfAvaliableTable(day.date),
          }"
          @click="setDateSelected(day.date)"
        >
          <span class="capitalize">{{ day.dayWeek }}</span>
          <span class="">{{ day.dayMonth }}</span>
        </div>
        <button v-ripple @click="openCalendarModal" class="day-of-week">
          <span></span><span></span><span class="font-bold">...</span>
        </button>
      </div>
    </div>
    <v-overlay absolute :value="modal">
      <div class="calendar-container">
        <v-calendar
          is-expanded
          :locale="locale"
          :masks="{ title: 'MMMM', weekdays: 'WW' }"
          :first-day-of-week="2"
          nav-visibility="hidden"
          :attributes="attrs"
          :disabled-dates="{ weekdays: [2] }"
          :min-date="new Date()"
          @dayclick="dayclick"
          color="gray"
          ref="calendar"
          :key="key"
        >
        </v-calendar>
        <div class="flex w-full justify-end py-1">
          <button @click="modal = false" class="btn-text-primary mr-2" v-ripple>
            {{ $t("wizard.close") }}
          </button>
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { getDates } from "../../../utils.js";
import moment from "moment";

export default {
  data: () => {
    return {
      modal: false,
      absolute: true,
      locale: window.appLocale,
      key: 0,
    };
  },
  computed: {
    ...mapGetters({
      dateSelected: "getDate",
      avaliableDates: "getAvaliableDates",
      exceptions: "getExceptions"
    }),
    days() {
      var startDate = new Date();
      var aryDates = getDates(startDate, 6);
      return aryDates;
    },
    attrs() {
      return [
        {
          highlight: true,
          dates: this.dateSelected,
        },
      ];
    },
    disabledDates() {
      return [];
    },
    maxDate() {
      var currentTime = new Date();
      currentTime.setDate(currentTime.getDate() + 13);
      return currentTime;
    },
  },
  methods: {
    ...mapMutations(["setDate"]),
    setDateSelected(date) {
      this.setDate(date);
    },
    isDateSelected(date) {
      if (!this.dateSelected) return false;
      const dateFormat = moment(date).format("L");
      const dateSelectedFormat = moment(this.dateSelected).format("L");

      return dateFormat == dateSelectedFormat;
    },
    isClosedDay(date) {
      date = moment(date);
      switch (date.day()) {
        case 1:
          return true;
        default:
          let hasException = false;
          this.exceptions.forEach(exception => {
            if (date.isSame(exception.date, 'day') && !exception.range){
              hasException = true;
            }
          });
          return hasException;
      }
    },
    openCalendarModal() {
      this.modal = true;
    },
    dayclick({ year, month, day }) {
      const date = new Date(year, month - 1, day);
      const dateFormat = moment(date);
      if (!this.isClosedDay(dateFormat.format()))
        this.setDateSelected(dateFormat.format());
    },
    checkIfAvaliableTable(date) {
      if (this.avaliableDates.length == 0) return true;

      const day = date.split("T")[0];
      const avaliableDay = this.avaliableDates.find((date) => date.date == day);
      if (avaliableDay) return avaliableDay.availability.length > 0;
      else return false;
    },
  },
};
</script>

<style lang="scss">
@import "../../../../sass/variables.scss";

.date-section {
  width: 100%;
  &__container {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(auto-fill, 58px);

    .day-of-week {
      position: relative;
      // transition: all ease-in-out 0.2s;
      cursor: pointer;
      width: 58px;
      height: 58px;
      border: 1px solid #afafaf;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      border-radius: 10px;
      transition: all ease-in-out 0.1s;

      &:hover {
        background: #e4e4e4;
        border-color: #6f6f6f;
      }

      &.selected {
        background-color: $black;
        color: $white;
      }

      &.disabled {
        background-color: #edebe7;
        color: #bdbdbd;
        pointer-events: none;
        cursor: not-allowed;
      }
    }
  }
}

.v-overlay__content {
  width: 100%;
  display: flex;
  justify-content: center;

  .calendar-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0 8px 0;
    flex-direction: column;
    background-color: $white;
    width: 100%;
    max-width: 363px;
    .vc-container {
      border: 0;
      width: 100%;
    }
    .vc-pane-container {
      .vc-arrows-container {
        width: 80% !important;
        left: 10% !important;

        .vc-arrow {
          color: black;
        }
      }

      .vc-header {
        padding-bottom: 10px;
        border-bottom: 1px solid #a1a1a1;
        color: #000000;
        font-weight: bold;
        font-size: 13px;
      }
      .vc-weekday {
        color: #000000;
        font-size: 12px;
        border-bottom: 1px solid #d7d7d7;
        padding-top: 8px;
      }

      .vc-highlights.vc-day-layer {
        .vc-highlight {
          width: 100%;
          height: 100%;
          border-radius: 0 !important;
          background-color: black !important;
        }
      }

      .vc-day {
        min-height: 50px;
        border-bottom: 1px solid #d7d7d7;
        border-right: 1px solid #d7d7d7;

        &.weekday-position-7 {
            border-right: none;
        }

        &-content {
            &.is-disabled {
                background-color: #f5f5f5;
                color: #bdbdbd;
                pointer-events: none;
            }
        }
      }

      .vc-weeks {
          padding: 5px 0;
      }

      .vc-day-content {
        width: 100%;
        height: 100%;
        border-radius: 0;
        &:hover {
          // border: 1px solid #a9a9a9;
        }
      }

      .vc-title {
        text-transform: uppercase;
      }
    }
  }
}
</style>
